import React from 'react';
import './LeftBarContainer.css';

function GroupButtons({ children, style }) {
  return (
    <div className={'flexRow group-buttons'} style={style}>
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  );
}

export default GroupButtons;
